var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.327,
    height: 15.302,
    viewBox: "0 0 14.327 15.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(0.05 0.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4617",
    "data-name": "Group 4617",
    transform: "translate(6.451 8.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5227",
    "data-name": "Path 5227",
    d: "M11.225,17.734H9.358a.358.358,0,0,1,0-.717h1.867A1.076,1.076,0,0,0,12.3,15.942V13.358a.358.358,0,1,1,.717,0v2.584A1.794,1.794,0,0,1,11.225,17.734Z",
    transform: "translate(-9 -13)",
    fill: "#32315c",
    stroke: "#32315c",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4618",
    "data-name": "Group 4618",
    transform: "translate(8.318 6.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5228",
    "data-name": "Path 5228",
    d: "M20.526,10.717H15.358a.358.358,0,1,1,0-.717h5.168a.358.358,0,1,1,0,.717Z",
    transform: "translate(-15 -10)",
    fill: "#32315c",
    stroke: "#32315c",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4619",
    "data-name": "Group 4619",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5229",
    "data-name": "Path 5229",
    d: "M5.734,16.2a1.366,1.366,0,0,1-.457-.078L.983,14.693A1.432,1.432,0,0,1,0,13.335V2.434A1.435,1.435,0,0,1,1.434,1a1.34,1.34,0,0,1,.458.079L6.184,2.509a1.431,1.431,0,0,1,.983,1.358v10.9A1.435,1.435,0,0,1,5.734,16.2ZM1.434,1.717a.717.717,0,0,0-.717.717v10.9a.717.717,0,0,0,.493.678l4.3,1.434a.715.715,0,0,0,.94-.678V3.867a.714.714,0,0,0-.493-.677l-4.3-1.434a.66.66,0,0,0-.224-.039Z",
    transform: "translate(0 -1)",
    fill: "#32315c",
    stroke: "#32315c",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4620",
    "data-name": "Group 4620",
    transform: "translate(1.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5230",
    "data-name": "Path 5230",
    d: "M10.535,4.734a.359.359,0,0,1-.358-.358V1.792A1.076,1.076,0,0,0,9.1.717H1.858a.358.358,0,0,1,0-.717H9.1a1.794,1.794,0,0,1,1.792,1.792V4.376A.359.359,0,0,1,10.535,4.734Z",
    transform: "translate(-1.5)",
    fill: "#32315c",
    stroke: "#32315c",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4621",
    "data-name": "Group 4621",
    transform: "translate(11.618 4.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5231",
    "data-name": "Path 5231",
    d: "M20.358,11.451a.358.358,0,0,1-.254-.611l1.613-1.613L20.1,7.613a.358.358,0,0,1,.507-.507l1.867,1.867a.359.359,0,0,1,0,.507l-1.867,1.867A.359.359,0,0,1,20.358,11.451Z",
    transform: "translate(-20 -7.002)",
    fill: "#32315c",
    stroke: "#32315c",
    strokeWidth: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e16aece213b781439735a3adae3c63d8.svg";
export { ForwardRef as ReactComponent };